'use client';

import { DMLink } from '@/components/link';
import { getFirstLetters } from '@/lib/utils';
import LevelUpModal from '@/screens/level-up/level-up-modal';
import { useSession } from 'next-auth/react';

function Avatar() {
  const session = useSession();
  const { data } = session;
  return (
    <div className='relative bg-slate-800 h-10 w-9 md:w-14 rounded-xl flex justify-start items-center md:mr-3'>
      <div className='ml-[3px] h-full flex items-center'>
        <LevelUpModal />
      </div>
      <DMLink
        href='/profile'
        className='hidden md:flex absolute -right-5 h-full bg-brand-primary hover:text-white rounded-xl w-10 items-center justify-center text-black uppercase'
      >
        {data?.user?.name && getFirstLetters(data?.user?.name)}
      </DMLink>
    </div>
  );
}

export default Avatar;
